'use client';

import React from 'react';
import LanguageSelector from './LanguageSelector';
import SearchPanel from './SearchPanel';
import AreaSelector from './AreaSelector';
import { HeaderProps } from '@/page-builder/global/mappers/header.mapper';

export const TopBar = ({ topBar, menuItems, searchTrends }: HeaderProps) => {
  return (
    <div className="general-bar-bg bg-primary-100">
      <div className="general-bar">
        <nav className="panels-menu" aria-label="Opções navegação geral">
          <ul>
            {topBar && topBar.enableLanguageSelector && <li>
              <LanguageSelector />
            </li> }
            {topBar && topBar.enableSearch && <li>
              <SearchPanel popularLinks={searchTrends || []} />
            </li>}
          </ul>
        </nav>

        <AreaSelector topBar={topBar} menuItems={menuItems} />
       
      </div>
    </div>
  );
};